import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/envelope-open': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M494.6 164.5c9.6 7.9 17.4 24.5 17.4 37v262.5c0 26.5-21.5 48-48 48h-416c-26.5 0-48-21.5-48-48v-262.5c0-12.5 7.8-29.1 17.5-37.1 4.1-3.4 110.7-89.1 135.2-108.5 22.7-18.1 60.1-55.9 103.3-55.9 43.4 0 81.2 38.2 103.3 55.9 23.5 18.7 130.6 104.8 135.3 108.7zM464 458v-253.6 0c0-1.6-1-3.7-2.2-4.7-15.9-12.8-108.8-87.6-132.4-106.3-17.6-14-49.7-45.4-73.4-45.4-23.6 0-55.2 30.9-73.4 45.4-23.6 18.7-116.5 93.5-132.4 106.3-1.4 1.1-2.2 2.9-2.2 4.7v253.7c0 3.3 2.7 6 6 6h404c3.3 0 6-2.7 6-6zM432 270.3c4.2 5.2 3.5 12.8-1.7 17-29 23.3-59.3 47.6-70.9 56.9-22.7 18.1-60.1 55.9-103.3 55.9-43.5 0-81.3-38.2-103.3-55.9-11.3-9-41.7-33.4-70.9-56.9-5.2-4.2-6-11.8-1.7-17l15.3-18.5c4.2-5.1 11.7-5.8 16.8-1.7 28.6 23 58.6 47 70.6 56.6 17.6 14 49.7 45.4 73.4 45.4 23.6 0 55.2-30.9 73.4-45.4 12-9.5 41.9-33.6 70.6-56.6 5.1-4.1 12.6-3.3 16.8 1.7z'
      }
    ]
  }
})
